module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av50-57873e092bb18a49a832169e98b5396d.jpg";